const excluded = new Set(["impressum", "geschichte"])

module.exports = excluded
